import React, { ReactElement } from "react";
import {
  IconClubCatchCart,
  IconClubCatchMail,
  IconClubCatchMonitor,
  IconClubCatchShipping,
  IconDiscountTag,
  IconFlybuysCard,
} from "@catchoftheday/cg-components";

type ClubFeature = {
  icon: ReactElement;
  title: string;
};

export const features: ClubFeature[] = [
  {
    icon: (
      <IconClubCatchShipping
        color="brand.clubCatch"
        width={{ xs: "60px", md: "60px", lg: "91px" }}
        height="auto"
      />
    ),
    title: "Enjoy Free Shipping",
  },
  {
    icon: (
      <IconClubCatchMonitor
        color="brand.clubCatch"
        width={{ xs: "45px", md: "45px", lg: "60px" }}
        height="auto"
      />
    ),
    title: "Weekly Exclusive Deals",
  },
  {
    icon: (
      <IconDiscountTag
        color="brand.clubCatch"
        width={{ xs: "46px", md: "46px", lg: "64px" }}
        height="auto"
      />
    ),
    title: "Sitewide Club Discounts",
  },
  {
    icon: (
      <IconClubCatchMail
        color="brand.clubCatch"
        width={{ xs: "45px", lg: "45px", xl: "68px" }}
        height="auto"
      />
    ),
    title: "Early Alerts to Sales",
  },
  {
    icon: (
      <IconClubCatchCart
        color="brand.clubCatch"
        width={{ xs: "45px", md: "45px", lg: "45px", xl: "60px" }}
        height="auto"
      />
    ),
    title: "Free Pick Up at Target & Kmart",
  },
  {
    icon: (
      <IconFlybuysCard
        color="brand.clubCatch"
        width={{ xs: "38px", md: "38px", lg: "38px", xl: "55px" }}
        height="auto"
      />
    ),
    title: " Collect Double Flybuys Points",
  },
];
